<template>
    <div v-if="medicalRecord !== null">
        <div id="medical-record-viewer">
            <b-form-textarea
                  v-model="medicalRecord.body"
                  readonly
                  :rows="10"
                  :max-rows="10"
                  id="medical-record-viewer__textarea">
            </b-form-textarea>
        </div>

        <div
            v-if="publishedAt"
            class="mt-3 d-flex justify-content-between align-items-center">
            <div class="text-muted">公開日時:&nbsp;{{ publishedAt }}</div>
        </div>
    </div>
</template>

<script>
    import YokumiruHelper from '../../YokumiruHelper'
    import constants from '../../constants'
    import moment from 'moment-timezone'

    export default {
        props: {
            medicalRecord: {
                type: Object,
                default: null,
            },
        },

        computed: {
            /**
             * 公開日フォーマット
             *
             * @return {string}
             */
            publishedAt: function () {
                if (this.medicalRecord && this.medicalRecord.published_at) {
                    return moment(this.medicalRecord.published_at).locale('ja').format('YYYY年M月D日(ddd) HH:mm')
                }
                return ''
            },
        },

        created: function () {
            const exists = !!this.medicalRecord.body
            bus.$emit('update-tab-css', 'medical_record', exists)
        },

        beforeDestroy: function () {
            bus.$off('update-tab-css')
        },
    }
</script>

<style lang="scss">
    #medical-record-viewer {
        #medical-record-viewer__textarea {
            background: #fff;
            cursor: default;
        }
    }
</style>
